
import { createSlice } from "@reduxjs/toolkit";

interface FilterSliceState {
    filterData: any;
    filterDataforApi: any;
    rowCount: any;
    pageNo: any;
    colSort: any;
}
const filterSlice = createSlice({
    name: "filterSlice",
    initialState: {
        filterData: [],
        filterDataforApi: [],
        rowCount: 10,
        pageNo: 0,
        colSort: false
    },
    reducers: {
        setFilter(state, action) {
            state.filterData = action.payload;
        },
        setFilterDataForApi(state, action) {
            const next = action.payload;
            const prev = state.filterDataforApi;
            const prevEmpty = !prev || (Array.isArray(prev) && prev.length === 0);
            const nextEmpty = !next || (Array.isArray(next) && next.length === 0);
            if (prevEmpty && nextEmpty) {
                return;
            }
            if (Array.isArray(prev) && Array.isArray(next) && prev.length === next.length && prev.every((item, i) => item === next[i])) {
                return;
            }
            state.filterDataforApi = next;
        },
        setRowCount(state, action) {
            state.rowCount = action.payload;
        },
        setPageNo(state, action) {
            state.pageNo = action.payload;
        },
        setColSort(state, action) {
            state.colSort = action.payload;
        },
        setFilterSliceInitState(state) {
            state.filterDataforApi = [];
            state.filterData = [];
            state.rowCount = 10;
            state.pageNo = 0;
            state.colSort = false;
        },
    },
});

export default filterSlice.reducer;
export const { setFilter, setFilterDataForApi, setRowCount, setFilterSliceInitState, setPageNo, setColSort } = filterSlice.actions;

export const rowCount = (state: { filterSlice: FilterSliceState }) =>
    state.filterSlice.rowCount;
export const filterData = (state: { filterSlice: FilterSliceState }) =>
    state.filterSlice.filterData;
export const filterDataforApi = (state: { filterSlice: FilterSliceState }) =>
    state.filterSlice.filterDataforApi;
export const pageNo = (state: { filterSlice: FilterSliceState }) =>
    state.filterSlice.pageNo;
export const colSort = (state: { filterSlice: FilterSliceState }) =>
    state.filterSlice.colSort;


